












import { Component, Prop, Vue } from 'vue-property-decorator';

// 颜色块(最小单元)
@Component
export default class ColorWheelUnit extends Vue {
  @Prop() public color!: string;
  @Prop() public width!: number | string;                               // 颜色块的宽度
  @Prop() public height!: number | string;                              // 颜色块的高度
  @Prop({ type: Boolean, default: false }) public dark!: boolean;       // 是否是暗色
  @Prop({ type: Boolean, default: false }) public checked!: boolean;    // 是否已经选中
  @Prop({ type: Boolean, default: true }) public hoverable!: boolean;   // 是否显示鼠标悬浮效果
  @Prop({ type: Boolean, default: false }) public selectable!: boolean; // 是否允许选择

  public get wrapStyle() {
    const width = parseInt(`${this.width}`, 10) || 0;
    const height = parseInt(`${this.height}`, 10) || 0;
    if (width && height) {
      // 如果宽度和高度都有值，则固定宽高
      return { width: `${width}px`, height: `${height}px` };
    } else if (width && !height) {
      // 如果只有宽度值，则宽度固定，高度自适应
      return { width: `${width}px`, flex: 1 };
    } else if (!width && height) {
      // 如果只有高度值，则高度固定，宽度自适应
      return { height: `${height}px`, flex: 1 };
    } else {
      return null;
    }
  }

  public get innerStyle() {
    return {
      height: '100%',
      backgroundColor: this.color,
      cursor: this.selectable ? 'pointer' : 'default',
    };
  }

  public get innerCls() {
    return this.hoverable ? 'color-wheel-unit' : '';
  }

  // emit: click
  public onClick(e: MouseEvent) {
    if (this.selectable) {
      this.$emit('click', e);
    }
  }
}
